/**
 * Realtime voice AI providers a phone-call session can run on.
 */

import { z } from "zod";

/** Supported voice AI providers for realtime phone call sessions. */
export const VOICE_PROVIDERS = ["openai", "gemini", "gpt-live"] as const;
export const VoiceProviderSchema = z.enum(VOICE_PROVIDERS);
export type VoiceProvider = z.infer<typeof VoiceProviderSchema>;

/**
 * What a voice config that names no `provider` runs on. Every config written before
 * the choice existed names none, and those calls have always been OpenAI Realtime.
 */
export const VOICE_PROVIDER_WHEN_UNSET: VoiceProvider = "openai";
